import React from "react";
import { LogUploadSourceType } from "types/api/aiRiskMgmt";

import { LogFileUpload } from "../GenericIntegration";

export default function ZscalerFileUpload() {
  return (
    <LogFileUpload
      sourceType={LogUploadSourceType.ZSCALER}
      label="Zscaler ZIA"
    />
  );
}
